// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj;
export var blue = (_obj = {}, _define_property(_obj, 50, '#E9F3FF'), _define_property(_obj, 100, '#D3E7FF'), _define_property(_obj, 200, '#B8D8FF'), _define_property(_obj, 300, '#99C7FF'), _define_property(_obj, 400, '#66ABFF'), _define_property(_obj, 500, '#006AED'), _define_property(_obj, 600, '#005BCC'), _define_property(_obj, 700, '#004EAD'), _define_property(_obj, 800, '#00377B'), _define_property(_obj, 900, '#00224D'), _define_property(_obj, 950, '#001229'), _obj);

//# sourceMappingURL=blue.js.map